export default "__VITE_ASSET__DLZ1wbw___"